var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTip1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4693877,32 L6.53061225,32 C2.9387755,32 0,29.0612245 0,25.4693877 L0,6.53061225 C0,2.9387755 2.9387755,0 6.53061225,0 L25.4693877,0 C29.0612245,0 32,2.9387755 32,6.53061225 L32,25.4693877 C32,29.0612245 29.0612245,32 25.4693877,32 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FF9311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8571428,6.53061225 L9.14285716,6.53061225 C7.70612247,6.53061225 6.53061225,7.70612247 6.53061225,9.14285716 L6.53061225,22.8571428 C6.53061225,24.2938775 7.70612247,25.4693877 9.14285716,25.4693877 L22.8571428,25.4693877 C24.2938775,25.4693877 25.4693878,24.2938775 25.4693878,22.8571428 L25.4693878,9.14285716 C25.4693878,7.70612247 24.2938775,6.53061225 22.8571428,6.53061225 L22.8571428,6.53061225 Z",
    id: "\\u8DEF\\u5F84",
    fillOpacity: 0.88,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.877551,23.8367347 L10.122449,23.8367347 C9.04489794,23.8367347 8.16326531,22.955102 8.16326531,21.877551 L8.16326531,10.122449 C8.16326531,9.04489794 9.04489797,8.16326531 10.122449,8.16326531 L21.877551,8.16326531 C22.9551021,8.16326531 23.8367347,9.04489797 23.8367347,10.122449 L23.8367347,21.877551 C23.8367347,22.9551021 22.955102,23.8367347 21.877551,23.8367347 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3877551,6.53061225 L13.3877551,12.0816327 C14.2693877,11.755102 15.1183673,11.4285714 16,11.1020408 C16.8816327,11.4285714 17.7306123,11.755102 18.6122449,12.0816327 L18.6122449,6.53061225 L13.3877551,6.53061225 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFC47D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FF9311",
    points: "16 13.4204082 17.1428572 15.7714286 19.722449 16.1306122 17.8612245 17.9591837 18.3183673 20.5387755 16 19.2979592 13.6816327 20.5387755 14.1387755 17.9591837 12.277551 16.1306122 14.8571428 15.7714286"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip1);
export default __webpack_public_path__ + "static/media/tip1.328749fe.svg";
export { ForwardRef as ReactComponent };